import { Button } from "primereact/button";

export default function Footer () {
  return <>
    <div className="footer_ghost" />
   <footer className="p-menubar footer">
    <div className="w-full" >
      <div className="flex flex-wrap w-full gap-2 justify-content-center">
          <Button icon="pi pi-youtube" rounded  onClick={() => window.open('https://www.youtube.com/channel/UCPEHhyb_1xEx4Il5-YJM81A', '_blank')?.focus() }/>
          <Button icon="pi pi-instagram" rounded onClick={() => window.open('https://www.instagram.com/unipigstudio/', '_blank')?.focus() } />
          <Button icon="pi pi-code" rounded onClick={() => window.open('https://dev.to/cesarpaulomp', '_blank')?.focus() } />
      </div>
      <div className="text-center w-full mt-3" >
        © Copyright 2024 Paulo César Medeiros Porto - All Rights Reserved
      </div>
    </div>
   </footer>
  </>
}